import AddedProductCard from '@components/added-product-card/added-product-card'
import { Button } from '@components/ui'
import { useUI } from '@components/ui/context'
import UpgradeProductCard from '@components/upgrade-product-card/upgrade-product-card'
import useCart from '@framework/cart/use-cart'
import itemFoundInCart from '@lib/itemFoundInCart'
import type { Product } from 'types/Product'

const UpgradeProductsSidebarView = ({
  onClose,
  products,
  type = 'upgrade',
  currentProduct,
}: {
  onClose: () => void
  products?: any[]
  type?: 'upgrade' | 'complete-the-look'
  currentProduct?: Product.Product
}) => {
  const { setSidebarView, openSidebar } = useUI()
  const { data } = useCart()

  const handleOpenCart = () => {
    onClose()
    setSidebarView('CART_VIEW')
    openSidebar()
  }
  if (!products || products.length === 0) {
    handleOpenCart()
    return null
  }

  return (
    <div className="flex-1 flex flex-col items-start justify-start">
      <div className="flex flex-1 flex-col">
        {currentProduct && (
          <div className="flex flex-col px-[20px] pt-6 pb-3 gap-4">
            <h4 className="text-body3 sm:text-label sm:text-left">
              Added to cart...
            </h4>
            <AddedProductCard {...currentProduct} />
          </div>
        )}
        <hr />
        {type === 'upgrade' && (
          <div className="flex flex-col px-[20px] pt-[12px] text-center">
            <p className="text-body3 sm:text-label text-center">
              Display chain included.
            </p>
          </div>
        )}
        <div className="px-[20px] pt-4">
          <h3 className="text-brand-dark-grey text-body3 font-bold sm:text-label text-center">
            {type === 'upgrade' ? 'UPGRADE YOUR CHAIN' : 'COMPLETE THE LOOK'}
          </h3>
        </div>
        <div className="grid grid-cols-3 gap-1 px-[20px] py-[24px]">
          {products.map((product) => (
            <UpgradeProductCard
              key={product.id}
              product={product}
              onClose={onClose}
              inCart={
                !!itemFoundInCart(data?.lineItems || [], product.handle).item
              }
            />
          ))}
        </div>
      </div>
      <div className="flex-shrink-0 px-[20px] py-[24px] sticky z-10 bottom-0 w-full right-0 left-0 bg-accent-0 border-t text-[13px]">
        <div className="py-[5px]">
          <Button variant="ghost" width="100%" onClick={onClose}>
            Continue Shopping
          </Button>
        </div>
        <div className="py-[5px]">
          <Button variant="slim" width="100%" onClick={handleOpenCart}>
            View Cart
          </Button>
        </div>
      </div>
    </div>
  )
}

export default UpgradeProductsSidebarView
